import clsx from 'clsx';
import React from 'react';
import "./view-archive-status.style.scss";
export const ViewArchiveInfo = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    className,
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('view-archive-info', className),
    ref: ref
  }, children);
});